module.exports = __webpack_public_path__ + "static/media/Parliament_Foyer_882x496_Colour.e607c76f.png";